<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5" id="grad1">
          <!-- breadcrumb and title row starts -->
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard'
                  },

                  {
                    title: 'Training Wizard',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
            </div>
            <div class="col-sm-12">
              <div class="heading mt-3">
                <h3 class="text-secondary">Training Wizard</h3>
              </div>
            </div>
          </div>
          <!-- breadcrumb and title row Ends -->
          <div class="row justify-content-center mt-0">
            <div class="col-11 text-center p-0 mt-3 mb-2">
              <div class="card px-0 pb-0 mt-3 mb-3">
                <div class="row">
                  <div class="col-md-12 mx-0">
                    <form id="msform">
                      <!-- progressbar -->
                      <ul id="progressbar">
                        <li title="Warning! You are not authorized to access." id="NewTraining">
                          <strong>Training Assignment</strong>
                        </li>
                        <li title="Warning! You are not authorized to access." id="PoAssignment">
                          <strong>P.O Assignment</strong>
                        </li>
                        <li
                          @click="trainingInformation()"
                          class="completed"
                          id="TrainingInformation"
                        >
                          <strong>Training Information</strong>
                        </li>
                        <li class="active" id="TrainerRegistration">
                          <strong>Trainer Registration</strong>
                        </li>
                        <li @click="trainingAgenda()" id="TrainingAgenda">
                          <strong>Training Agenda</strong>
                        </li>
                        <li @click="trainingAssessment()" id="TrainingAssessments">
                          <strong>Training Assessments</strong>
                        </li>

                        <li @click="traineeReg()" id="TraineeRegistration">
                          <strong>Trainee Registration</strong>
                        </li>
                        <li @click="assessmentReviewFunction()" id="AssessmentReview">
                          <strong>Assessment Review</strong>
                        </li>
                        <li @click="trainingCompletion()" id="Completion">
                          <strong>Completion</strong>
                        </li>
                      </ul>
                      <!-- fieldsets -->
                      <fieldset style="text-align: left;padding: 30px;">
                        <vs-tabs class="custom-tabs" alignment="fixed">
                          <vs-tab label="Quick Trainer Registration">
                            <div class="row mt-5">
                              <b-card v-if="isForm">
                                <form @submit.prevent="quickRegistration">
                                  <!--Detail Information starts -->
                                  <div class="form-group form-row">
                                    <div class="col-sm-6 mb-2">
                                      <div class="floating-label">
                                        <input
                                          class="floating-input form-control"
                                          type="text"
                                          placeholder=" "
                                          v-model="name"
                                          autocomplete="off"
                                        />
                                        <span
                                          class="lbl-label"
                                          style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                        >
                                          <i
                                            class="material-icons"
                                            style="font-size: 20px;"
                                          >account_circle</i>
                                        </span>
                                        <label class="lbl-label">
                                          Trainer Name
                                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-sm-6 mb-2">
                                      <div class="floating-label">
                                        <input
                                          class="floating-input form-control"
                                          v-mask="'(99999) 9999999-9'"
                                          type="text"
                                          placeholder=" "
                                          v-model="cnic"
                                          autocomplete="off"
                                        />

                                        <span
                                          class="lbl-label"
                                          style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                        >
                                          <i
                                            class="material-icons"
                                            style="font-size: 20px;"
                                          >credit_card</i>
                                        </span>
                                        <label class="lbl-label">
                                          CNIC
                                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-sm-6 mb-2 mt-3">
                                      <div class="floating-label">
                                        <input
                                          class="floating-input form-control"
                                          v-mask="'(9999)-9999999'"
                                          type="text"
                                          placeholder=" "
                                          v-model="mobilenumber"
                                        />

                                        <span
                                          class="lbl-label"
                                          style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                        >
                                          <i class="material-icons" style="font-size: 20px;">call</i>
                                        </span>
                                        <label class="lbl-label">
                                          Contact
                                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-sm-6 mb-2 mt-3">
                                      <div class="floating-label">
                                        <input
                                          class="floating-input form-control"
                                          v-model="passport"
                                          type="text"
                                          placeholder=" "
                                        />
                                        <span
                                          class="lbl-label"
                                          style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                        >
                                          <i
                                            class="material-icons"
                                            style="font-size: 20px;"
                                          >credit_card</i>
                                        </span>
                                        <label class="lbl-label">
                                          Passport
                                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-sm-6 mb-2 mt-3">
                                      <div class="floating-label">
                                        <input
                                          class="floating-input form-control"
                                          type="email"
                                          placeholder=" "
                                          v-model="email"
                                        />

                                        <span
                                          class="lbl-label"
                                          style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                        >
                                          <i class="material-icons" style="font-size: 20px;">email</i>
                                        </span>
                                        <label class="lbl-label">
                                          Email
                                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6 mb-2 mt-3">
                                      <div class="floating-label">
                                        <input
                                          class="floating-input form-control"
                                          v-model="code"
                                          type="text"
                                          placeholder=" "
                                        />

                                        <span
                                          class="lbl-label"
                                          style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;"
                                        >
                                          <i class="material-icons" style="font-size: 20px;">code</i>
                                        </span>
                                        <label class="lbl-label">
                                          Employee Code (This will use as
                                          password)
                                          <span
                                            style="color:rgba(255, 0, 0, 0.78);"
                                          >*</span>
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-sm-6 mt-3 mb-2">
                                      <div class="floating-label">
                                        <input
                                          class="floating-input form-control"
                                          hidden
                                          type="text"
                                          placeholder=" "
                                          v-model="role"
                                        />

                                        <span
                                          class="lbl-label"
                                          style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                        ></span>
                                      </div>
                                    </div>
                                  </div>
                                  <!--Detail Information ends -->

                                  <!-- save button starts-->
                                  <div class="row text-right">
                                    <div class="col-md-12">
                                      <b-button
                                        type="submit"
                                        class="btn btn-primary btn-sm"
                                        variant="primary"
                                      >Save</b-button>
                                    </div>
                                  </div>
                                  <!-- save button ends -->
                                </form>

                                <!-- Next Step Button Starts  -->
                                <div class="row mt-4">
                                  <div class="col-md-12 text-right">
                                    <router-link
                                      :to="{
                                path:
                                  '/dashboard/programOfficer/training-Information',
                                query: { trainingId: this.trainingCode }
                              }"
                                      class="btn btn-primary btn-sm m-1"
                                    >Previous Step</router-link>
                                    <router-link
                                      :to="{
                                path:
                                  '/dashboard/programOfficer/training-agenda',
                                query: { trainingId: this.trainingCode }
                              }"
                                      class="btn btn-primary btn-sm"
                                    >Next Step</router-link>
                                    <button
                                      type="button"
                                      v-on:click="allTrainer()"
                                      class="btn btn-primary btn-sm m-1"
                                    >
                                      <vs-icon icon="refresh" title="Refresh"></vs-icon>
                                    </button>
                                  </div>
                                </div>

                                <!-- Next Step Button Ends  -->
                              </b-card>
                              <b-card v-if="isEditForm" style="border: 1px dotted #07a7e14f;">
                                <form @submit.prevent="submitEditForm">
                                  <div class="form-group">
                                    <div class="row">
                                      <!-- floating input starts -->
                                      <div class="col-sm-6">
                                        <div class="floating-label">
                                          <input
                                            class="floating-input form-control"
                                            type="text"
                                            placeholder=" "
                                            v-model="name"
                                          />
                                          <span
                                            class="lbl-label"
                                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                          >
                                            <i
                                              class="material-icons"
                                              style="font-size: 20px;"
                                            >account_circle</i>
                                          </span>
                                          <label class="lbl-label">Trainer Name</label>
                                        </div>
                                      </div>
                                      <div class="col-sm-6">
                                        <div class="floating-label">
                                          <input
                                            class="floating-input form-control"
                                            v-mask="'(99999) 9999999-9'"
                                            type="text"
                                            placeholder=" "
                                            v-model="cnic"
                                          />

                                          <span
                                            class="lbl-label"
                                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                          >
                                            <i
                                              class="material-icons"
                                              style="font-size: 20px;"
                                            >credit_card</i>
                                          </span>
                                          <label class="lbl-label">CNIC</label>
                                        </div>
                                      </div>
                                      <div class="col-sm-6 mt-3">
                                        <div class="floating-label">
                                          <input
                                            class="floating-input form-control"
                                            v-mask="'(9999)-9999999'"
                                            type="text"
                                            placeholder=" "
                                            v-model="mobilenumber"
                                          />

                                          <span
                                            class="lbl-label"
                                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                          >
                                            <i class="material-icons" style="font-size: 20px;">call</i>
                                          </span>
                                          <label class="lbl-label">Contact</label>
                                        </div>
                                      </div>
                                      <div class="col-sm-6 mt-3">
                                        <div class="floating-label">
                                          <input
                                            class="floating-input form-control"
                                            v-model="passport"
                                            type="text"
                                            placeholder=" "
                                          />
                                          <span
                                            class="lbl-label"
                                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                          >
                                            <i
                                              class="material-icons"
                                              style="font-size: 20px;"
                                            >credit_card</i>
                                          </span>
                                          <label class="lbl-label">Passport</label>
                                        </div>
                                      </div>
                                      <div class="col-sm-6 mt-3">
                                        <div class="floating-label">
                                          <input
                                            class="floating-input form-control"
                                            disabled
                                            type="email"
                                            placeholder=" "
                                            v-model="email"
                                          />

                                          <span
                                            class="lbl-label"
                                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                          >
                                            <i class="material-icons" style="font-size: 20px;">email</i>
                                          </span>
                                          <label class="lbl-label">Email</label>
                                        </div>
                                      </div>
                                      <div class="col-md-6 col-lg-6 mt-3">
                                        <div class="floating-label">
                                          <input
                                            class="floating-input form-control"
                                            v-model="code"
                                            type="text"
                                            placeholder=" "
                                          />

                                          <span
                                            class="lbl-label"
                                            style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;"
                                          >
                                            <i class="material-icons" style="font-size: 20px;">code</i>
                                          </span>
                                          <label class="lbl-label">
                                            Employee Code (This will use as
                                            password)
                                          </label>
                                        </div>
                                      </div>
                                      <!-- Gender ends -->
                                    </div>
                                  </div>
                                  <input type="hidden" v-model="userId" />
                                  <input type="hidden" v-model="primaryUserId" />
                                  <div class="form-group">
                                    <div class="row">
                                      <div class="col-sm-12">
                                        <!-- add button starts-->
                                        <b-button
                                          type="submit"
                                          class="save-btn"
                                          variant="primary"
                                        >Update</b-button>
                                        <b-button
                                          v-if="!isForm"
                                          @click="closeEditForm"
                                          variant="outline-info"
                                        >Cancel</b-button>
                                        <!-- add button ends -->
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </b-card>
                              <div class="table-responsive">
                                <div class="col-sm-12">
                                  <!-- new form popup starts -->
                                  <b-card>
                                    <div class="form-group">
                                      <div class="row">
                                        <div class="col-sm-12">
                                          <table class="table table-hover">
                                            <tr>
                                              <th>Sr#</th>
                                              <th>Trainer Name</th>
                                              <th>CNIC</th>
                                              <th>Passport</th>
                                              <th>Contact Number</th>
                                              <th>Email</th>
                                              <th>Password</th>
                                              <th>Action</th>
                                            </tr>

                                            <tr
                                              v-for="(item,
                                              index) in newTrainer"
                                              v-bind:key="item.trainer.id"
                                            >
                                              <td>{{ index + 1 }}</td>
                                              <td
                                                v-if="item.trainer.name != null"
                                                class="text-capitalize"
                                              >{{ item.trainer.name }}</td>
                                              <td v-else>--</td>
                                              <td
                                                v-if="item.trainer.cnic != null"
                                              >{{ item.trainer.cnic }}</td>
                                              <td v-else>--</td>
                                              <td
                                                v-if="
                                                  item.trainer.passport != null
                                                "
                                              >{{ item.trainer.passport }}</td>
                                              <td v-else>--</td>
                                              <td
                                                v-if="
                                                  item.trainer.mobile != null
                                                "
                                              >{{ item.trainer.mobile }}</td>
                                              <td v-else>--</td>
                                              <td
                                                v-if="
                                                  item.trainer.email != null
                                                "
                                              >{{ item.trainer.email }}</td>
                                              <td v-else>--</td>
                                              <td
                                                v-if="
                                                  item.trainer.trainer_user_id
                                                    .code != null
                                                "
                                              >
                                                {{
                                                item.trainer.trainer_user_id
                                                .code
                                                }}
                                              </td>
                                              <td v-else>--</td>
                                              <td>
                                                <a
                                                  @click="
                                                    editRecord(item.trainer.id)
                                                  "
                                                >
                                                  <vs-icon
                                                    class="mr-1"
                                                    icon="edit"
                                                    style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                                  ></vs-icon>
                                                </a>
                                                <a
                                                  @click="
                                                    deleteRecord(
                                                      item.trainer.id
                                                    )
                                                  "
                                                >
                                                  <vs-icon
                                                    class="mr-1"
                                                    icon="delete"
                                                    style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                                  ></vs-icon>
                                                </a>
                                              </td>
                                            </tr>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </b-card>
                                  <!-- new form popup ends -->
                                </div>
                              </div>
                            </div>
                          </vs-tab>
                          <vs-tab label="Registered Trainer">
                            <div class="table-responsive">
                              <div class="col-sm-12">
                                <!-- new form popup starts -->
                                <b-card>
                                  <div class="form-group">
                                    <div class="row">
                                      <div class="col-sm-12">
                                        <div class="col-sm-4 float-right mb-2 p-0">
                                        <input
                                          type="text"
                                          placeholder="Search ..."
                                          v-model="searchQuery"
                                          class="search_button form-control form-control-sm"
                                        />
                                        </div>
                                        <table class="table table-hover">
                                          <tr style="color: #000 !important;">
                                            <th>Sr#</th>
                                            <th>Trainer Name</th>
                                            <th>CNIC</th>
                                            <th>Passport</th>
                                            <th>Email</th>
                                            <th>Address</th>
                                            <th>Action</th>
                                          </tr>

                                          <tr
                                            v-for="(item,
                                            index) in filterData"
                                            v-bind:key="item.id"
                                          >
                                            <td>{{ index + 1 }}</td>
                                            <td
                                              v-if="item.name != null"
                                              class="text-capitalize"
                                            >{{ item.name }}</td>
                                            <td v-else>--</td>
                                            <td v-if="item.cnic != null">{{ item.cnic }}</td>
                                            <td v-else>--</td>
                                            <td v-if="item.passport != null">{{ item.passport }}</td>
                                            <td v-else>--</td>
                                            <td v-if="item.email != null">{{ item.email }}</td>
                                            <td v-else>--</td>
                                            <td v-if="item.address != null">{{ item.address }}</td>
                                            <td v-else>--</td>

                                            <td v-if="item.status == 'found'">
                                              <span>
                                                <a
                                                  @click="
                                                    unassignedTraining(item.id)
                                                  "
                                                >
                                                  <vs-chip color="danger">Un Select</vs-chip>
                                                </a>
                                              </span>
                                            </td>
                                            <td v-else>
                                              <a
                                                @click="
                                                  assignedTraining(item.id)
                                                "
                                              >
                                                <vs-chip color="success">Select for Training</vs-chip>
                                              </a>
                                            </td>
                                          </tr>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </b-card>
                                <!-- new form popup ends -->
                              </div>
                            </div>
                          </vs-tab>
                        </vs-tabs>

                        <!-- row 1 starts  -->
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "./Navbar";
import Selectize from "vue2-selectize";
import Sidebar from "./Sidebar";
import axios from "axios";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  data: () => ({
    isSidebar: false,
    isEditForm: false,
    whichSelect: 0,
    passport: "",
    trainingId: "",
    trainingCode: "",
    valuesArray: [],
    updateTraining: [],
    options1: [
      { text: "Passport", value: 0 },
      { text: "CNIC", value: 1 }
    ],
    radios1: "",
    gender: "",
    success: "",
    inValid: [],
    isForm: true,
    isFormData: false,
    tabIndex: 0,
    indexActive: 0,
    contact_person: "",
    contact_number: "",
    contact_email: "",
    address: "",
    options: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    components: {
      VueTagsInput
    },
    tag: "",
    mobilenumber: "",
    cnic: "",
    name: "",
    email: "",
    tags: [],
    role: "",
    rolesArr: [],
    roleuser: "",
    primaryUserId: "",
    departmentArr: [],
    designationArr: [],
    checkTraining: [],
    sessionByArray: [],
    checkBox1: false,
    checkBox2: false,
    checkBox3: false,
    checkBox4: false,
    textarea: "",
    counterDanger: false,
    mydate: "",
    startDate: "",
    endDate: "",
    colorx: "#1db952",
    trainingCheck: false,
    searchQuery: "",
    repeatedCheck: false,
    select1Normal: "",
    select1: 0,
    select2: 1,
    select3: 0,
    select4: 1,
    select5: 1,
    select6: 1,
    select7: 1,
    select8: 1,
    select9: 1,
    select10: 0,
    select11: 1,
    select12: 1,
    select13: 1,
    select14: 1,
    code: "",
    thematicareaSelected: "",
    thematicareasettings: {
      valueField: "code",
      labelField: "name",
      maxItems: 5,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    traineridentityArr: [
      { text: "CNIC Number", value: 1 },
      {
        text: "Passport Number",
        value: 2
      }
    ],
    languageskillsArr: [
      { text: "English", value: 1 },
      { text: "French", value: 2 },
      { text: "German", value: 3 },
      { text: "Chinese", value: 4 }
    ],
    selectlevelArr: [
      { text: "Good", value: 1 },
      { text: "Very Good", value: 2 },
      { text: "Excellent", value: 3 },
      { text: "Weak", value: 4 }
    ],
    countryArr: [],
    trainingArr: [
      { text: "Java", value: 1 },
      { text: "Wordpress", value: 2 },
      { text: "Web Development", value: 3 },
      { text: "Graphic Designing", value: 4 },
      { text: "Digital Marketing", value: 5 }
    ],
    provinceArr: [],
    districtArr: [],
    degreenameArr: [],
    degreesubjectArr: [
      { text: "Management Science", value: 1 },
      { text: "Computer Science", value: 2 },
      { text: "Software Engineering", value: 3 }
    ],
    jobnatureArr: [
      { text: "Permanent", value: 1 },
      { text: "Temporary", value: 2 }
    ],
    newTrainer: [],
    registeredTrainerArr: [],
    training_status: ""
  }),

  mounted() {
    this.trainingCode = this.$route.query.trainingId;

    //Select all countries

    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode
      ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.updateTraining = response.data.training;
        this.trainingId = response.data.training.id;
        this.training_status = response.data.training.trainingstatus;
        this.allTrainer();
        this.getTrainerTraning();
        this.getAllTraining();
      });
    axios
      .get(localStorage.getItem("BASE_PATH") + "/countries/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.countryArr = response.data;
        // this.provinceArr=response.data;
      });
    //get result of trainers
    axios
      .get(localStorage.getItem("BASE_PATH") + "/trainers/all/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.valuesArray = response.data;
      });
    //select all provinces
    axios
      .get(localStorage.getItem("BASE_PATH") + "/provinces/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.provinceArr = response.data;
      });
    //select all district
    axios
      .get(localStorage.getItem("BASE_PATH") + "/districts/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.districtArr = response.data;
      });
    //select all degree names
    axios
      .get(localStorage.getItem("BASE_PATH") + "/degreenames/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.degreenameArr = response.data;
      });
    // department
    axios
      .get(localStorage.getItem("BASE_PATH") + "/departments/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.departmentArr = response.data;
      });
    //designation
    axios
      .get(localStorage.getItem("BASE_PATH") + "/designations/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.designationArr = response.data;
      });
    axios
      .get(localStorage.getItem("BASE_PATH") + "/trainers/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.sessionByArray = response.data;
      });
    axios
      .get(localStorage.getItem("BASE_PATH") + "/trainer/role/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        // this.rolesArr = response.data;
        this.role = response.data[0].id;
      });
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },

  methods: {
    // onclick show wizard steps
    trainingInformation() {
      this.$router.push({
        path: "/dashboard/programOfficer/training-information",
        query: { trainingId: this.trainingCode }
      });
    },
    trainingAgenda() {
      if (this.training_status == "In Queue") {
        this.$toasted.global.errorMsg(
       'Please complete all steps by clicking on Save & Next button'
        );
      } else {
        this.$router.push({
          path: "/dashboard/programOfficer/training-agenda",
          query: { trainingId: this.trainingCode }
        });
      }
    },
    trainingMaterial() {
      if (this.training_status == "In Queue") {
        this.$toasted.global.errorMsg(
          "Please complete all steps by clicking on Save & Next button"
        );
      } else {
        this.$router.push({
          path: "/dashboard/programOfficer/wizardUploadMaterial",
          query: { trainingId: this.trainingCode }
        });
      }
    },
    trainingAssessment() {
      if (this.training_status == "In Queue") {
        this.$toasted.global.errorMsg(
          "Please complete all steps by clicking on Save & Next button"
        );
      } else {
        this.$router.push({
          path: "/dashboard/programOfficer/training-assesment",
          query: { trainingId: this.trainingCode }
        });
      }
    },
    traineeReg() {
      if (this.training_status == "In Queue") {
        this.$toasted.global.errorMsg(
          "Please complete all steps by clicking on Save & Next button"
        );
      } else {
        this.$router.push({
          path: "/dashboard/programOfficer/trainee-registration",
          query: { trainingId: this.trainingCode }
        });
      }
    },
    assessmentReviewFunction() {
      if (this.training_status == "In Queue") {
        this.$toasted.global.errorMsg(
          "Please complete all steps by clicking on Save & Next button"
        );
      } else {
        this.$router.push({
          path: "/dashboard/programOfficer/assesment-review",
          query: { trainingId: this.trainingCode }
        });
      }
    },
    trainingCompletion() {
      if (this.training_status == "In Queue") {
        this.$toasted.global.errorMsg(
          "Please complete all steps by clicking on Save & Next button"
        );
      } else {
        this.$router.push({
          path: "/dashboard/programOfficer/wizard-completion",
          query: { trainingId: this.trainingCode }
        });
      }
    },

    closeEditForm() {
      this.isForm = true;
      this.isEditForm = false;
      this.resetForm();
    },
    getAllTraining() {
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/trainer/get/all/" +
            this.trainingId
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.registeredTrainerArr = response.data;
        });
    },
    assignedTraining(id) {
      this.openLoading();
      axios
        .post(
          localStorage.getItem("BASE_PATH") + "/training/assigned/trainer",
          {
            trainingId: this.updateTraining.id,
            trainee: id
          }
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success) {
            this.$toasted.global.successMsg("Assigned Training successfully!");
            this.getAllTraining();
            this.allTrainer();
          }
        });
    },
    unassignedTraining(id) {
      this.openLoading();
      axios
        .post(
          localStorage.getItem("BASE_PATH") + "/training/un-assigned/trainer",
          {
            trainingId: this.updateTraining.id,
            trainee: id
          }
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success) {
            this.$toasted.global.successMsg("Training Un Assigned successfully!");
            this.getAllTraining();
            this.allTrainer();
          }
        });
    },

    editRecord(id) {
      this.isForm = false;
      this.isEditForm = true;
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") + "/trainer/user/" + id + "/edit"
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.name = response.data.name;
            this.code = response.data.trainer_user_id.code;
            this.mobilenumber = response.data.mobile;
            this.email = response.data.email;
            this.cnic = response.data.cnic;
            this.passport = response.data.passport;
            this.primaryUserId = response.data.trainer_id_user;
            this.userId = id;
            // this will scrollTop to edit form
            window.scrollTo(0, 0);
          }
        });
    },
    deleteRecord(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(localStorage.getItem("BASE_PATH") + "/trainer/delete", {
                id: id
              },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allTrainer();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    getTrainerTraning: function getAllTraining() {
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/all/trainer/training/get/" +
            this.trainingId
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          // this.rolesArr = response.data;
          this.checkTraining = response.data;
        });
    },

    allTrainer: function allTrainer() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/trainer/show/training/" +
            this.trainingId
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.newTrainer = response.data;
        });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    showinputvalue: function(event) {
      this.name = event.target.value;
    },
    //Quick training
    quickRegistration(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      // if (!this.cnic) {
      //   this.inValid.push("CNIC type is required.");
      // }
      if (!this.mobilenumber) {
        this.inValid.push("Mobile Number utype is required.");
      }
      if (!this.email) {
        this.inValid.push("Email type is required.");
      }
      var phone_no1 = this.mobilenumber;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      var cnic_var = this.cnic;
      if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      } else if (
        this.passport == undefined ||
        this.passport == null ||
        this.passport == ""
      ) {
        this.inValid.push("Please Enter Passport Number");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }

      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(
            localStorage.getItem("BASE_PATH") +
              "/programofficer/quick/registeration/trainer",
            {
              //insert User informatiion in user table
              name: this.name,
              code: this.code,
              role: this.role,
              contactNo: this.mobilenumber,
              email: this.email,
              training_id: this.trainingId,
              //insert trainee quick information in trainee table
              user_id: JSON.parse(localStorage.getItem("currentUser")).id,
              cnic: this.cnic,
              passport: this.passport,
              type: "Quick Registration"
            },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
         
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            if (response.data.success) {
              self.$toasted.global.successMsg("Record has been added successfully!");
              self.resetForm();
              self.allTrainer();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.$toasted.global.errorMsg(error);
          });
      }
    },
    submitEditForm(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.mobilenumber) {
        this.inValid.push("Mobile Number utype is required.");
      }
      if (!this.email) {
        this.inValid.push("Email type is required.");
      }
      var phone_no1 = this.mobilenumber;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      var cnic_var = this.cnic;
      if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      } else if (
        this.passport == undefined ||
        this.passport == null ||
        this.passport == ""
      ) {
        this.inValid.push("Please Enter Passport Number");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }

      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(localStorage.getItem("BASE_PATH") + "/trainer/update", {
            //insert User informatiion in user table

            name: this.name,
            code: this.code,
            role: this.role,
            contactNo: this.mobilenumber,
            email: this.email,
            //insert trainee quick information in trainee table
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            cnic: this.cnic,
            passport: this.passport,
            type: "Quick Registration",
            id: this.userId,
            primaryUserId: this.primaryUserId
          },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            if (response.data.success) {
              self.$toasted.global.successMsg("Record has been updated successfully!");
              self.resetForm();
              self.allTrainer();

              this.isForm = true;
              this.isEditForm = false;
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.$toasted.global.errorMsg(error);
          });
      }
    },
    resetForm() {
      this.name = "";
      this.cnic = "";
      this.code = "";
      this.passport = "";
      this.gender = "";
      this.mobilenumber = "";
      this.email = "";
      this.country = "";
      this.province = "";
      this.district = "";
      this.address = "";
      this.department_name = "";
      this.designation = "";
      this.certificate = "";
      this.passing_year = "";
      this.institute = "";
      this.training_name = "";
      this.training_code = "";
    },
    successUpload() {
      this.$vs.notify({
        color: "primary",
        title: "Upload Success",
        text: "Your file is uploaded Successfully."
      });
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    }
  },
  computed: {
    filterData: function() {
      return this.registeredTrainerArr.filter(items => {
        for (var item in items) {
          if (String(items[item]).toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1) {
            return true;
          }
        }
        return false;
      });
    }
  }
};
</script>

<style scoped>
#progressbar .completed {
  color: #06a6e0;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
  background: #06a6e0;
}

#grad1 {
  background-color: #fff;
}

#msform {
  text-align: center;
  position: relative;
  margin-top: 20px;
}

#msform fieldset .form-card {
  background: white;
  border: 0 none;
  border-radius: 0px;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  padding: 20px 40px 30px 40px;
  box-sizing: border-box;
  width: 94%;
  margin: 0 3% 20px 3%;
  position: relative;
}

#msform fieldset {
  padding: 10px;
  background: #f4f4f4;
  border: 0 none;
  border-radius: 2rem;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  border: 2px solid #ccc;
  padding-bottom: 20px;
  position: relative;
}

#msform fieldset:not(:first-of-type) {
  display: none;
}

#msform fieldset .form-card {
  text-align: left;
  color: #9e9e9e;
}

/* #msform input,
#msform textarea {
    padding: 0px 8px 4px 8px;
    border: none;
    border-bottom: 1px solid #ccc;
    border-radius: 0px;
    margin-bottom: 25px;
    margin-top: 2px;
    width: 100%;
    box-sizing: border-box;
    font-family: montserrat;
    color: #2c3e50;
    font-size: 16px;
    letter-spacing: 1px;
}

#msform input:focus,
#msform textarea:focus {
    -moz-box-shadow: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: none;
    font-weight: bold;
    border-bottom: 2px solid skyblue;
    outline-width: 0;
} */

#msform .action-button {
  width: 100px;
  background: skyblue;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
  width: 100px;
  background: #616161;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
  border: none;
  outline: 0;
  border-bottom: 1px solid #ccc;
  padding: 2px 5px 3px 5px;
  margin: 2px;
}

select.list-dt:focus {
  border-bottom: 2px solid skyblue;
}

.card {
  z-index: 0;
  border: none;
  border-radius: 0.5rem;
  position: relative;
}

.fs-title {
  font-size: 25px;
  color: #2c3e50;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: left;
}

#progressbar {
  margin-bottom: 30px;
  overflow: hidden;
  color: lightgrey;
}

#progressbar .active {
  color: #000000;
}

#progressbar li {
  list-style-type: none;
  font-size: 12px;
  width: 9.5%;
  text-align: center;
  float: left;
  position: relative;
}

#progressbar #NewTraining:before {
  content: "1";
}

#progressbar #PoAssignment:before {
  content: "2";
}

#progressbar #TrainingInformation:before {
  content: "3";
}
#progressbar #TrainerRegistration:before {
  content: "4a";
}
#progressbar #TrainingAgenda:before {
  content: "4b";
}
#progressbar #Trainingmaterial:before {
  content: "4c";
}

#progressbar #TrainingAssessments:before {
  content: "4d";
}
#progressbar #TraineeRegistration:before {
  content: "4e";
}

#progressbar #AssessmentReview:before {
  content: "5";
}

#progressbar #Completion:before {
  content: "6";
}

#progressbar li:before {
  width: 35px;
  height: 35px;
  line-height: 30px;
  display: block;
  font-size: 18px;
  color: #ffffff;
  background: lightgray;
  border-radius: 50%;
  margin: 0 auto 10px auto;
  padding: 2px;
}

#progressbar li:after {
  content: "";
  width: 100%;
  height: 2px;
  background: lightgray;
  position: absolute;
  left: 0;
  top: 17px;
  z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
  background: #000000;
}

.radio-group {
  position: relative;
  margin-bottom: 25px;
}

.radio {
  display: inline-block;
  width: 204;
  height: 104;
  border-radius: 0;
  background: lightblue;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  cursor: pointer;
  margin: 8px 2px;
}

.radio:hover {
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
  width: 100%;
  object-fit: cover;
}
.card-body {
  background-color: #f4f4f4 !important;
}
.vuesax-app-is-ltr .con-vs-chip {
  padding: 5px !important;
  /* padding-right: 10px; */
  cursor: pointer;
}
</style>
<style>
span.text-chip.vs-chip--text {
  margin-left: 0px !important;
}
.con-vs-chip.vs-chip-danger.con-color,
.con-vs-chip.vs-chip-success.con-color,
.con-vs-chip.vs-chip-warning.con-color {
  padding: 5px !important;
}
.vuesax-app-is-ltr .con-vs-chip {
  float: none !important;
}
.form-row {
  border: none !important;
  padding: 0px !important;
}
</style>
